<style lang="scss">
  @import "../sass/utilities/variables";
  @import "bootstrap-sass/assets/stylesheets/bootstrap/variables";
  @import "bootstrap-sass/assets/stylesheets/bootstrap/mixins";
  @import "bootstrap-sass/assets/stylesheets/bootstrap/popovers";

  .dont-break-out {
    background-color: $white;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }
</style>

<template>
  <a
    tabindex="0"
    style="outline: none;"
    data-toggle="popover"
    :data-trigger="trigger || 'focus'"
    :data-placement="placement || 'top'"
    data-html="true"
    data-content=""
    data-template='<div
        class="popover dont-break-out"
        role="tooltip"
      >
        <div class="arrow"></div>
        <h3 class="popover-title"></h3>
        <div class="popover-content"></div>
      </div>'
    @click.prevent
  >
    <slot name="trigger"></slot>
    <div class="hide_display popover-body">
      <slot name="body"></slot>
    </div>
  </a>
</template>

<script>
import { loadBootstrapPopoverPlugins } from '../js/load-popover-bootstrap-plugins';

export default {

  props: ['placement', 'trigger'],

  data() {
    return {
      $me: null,
    };
  },

  mounted() {
    this.mountDeferBootstrapPopoverPlugins();
  },

  methods: {
    mountDeferBootstrapPopoverPlugins() {
      if (typeof window.jQuery === 'undefined' || window.jQuery === null || !window.jQuery.fn) {
        return;
      }

      loadBootstrapPopoverPlugins().then(() => {
        if (typeof window.jQuery.fn.popover === 'function') {
          this.initializePopover();
        }
      });
    },

    initializePopover() {
      this.$me = window.jQuery(this.$el);

      this.$me.data('content', this.$me.find('.popover-body').html());
      this.$me.popover({ sanitize: false });

      this.$me.on('show.bs.popover', () => {
        this.$me.data('bs.popover').options.content = this.$me.find('.popover-body').html();
      });
    },
  },

};
</script>
